<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-12 17:10:00
 -->
<!--  -->
<template>
    <basicContainer>
        <div class="announcementManage">

            <!-- 主数据表 -->
            <easyCruds ref="mainTable" :tableInfo="mainTable"
                      @mainTableReload="mainTableReload"
                      @goReturn="goReturn"
                        @xnChange="xnChange"
                        @xyChange="xyChange">

                <template slot="bjmcForm" slot-scope="{row}" >
                    <el-link type="primary" @click="openFun(row)">{{row.bjmc}}</el-link>
                </template>
            </easyCruds>

        </div>
    </basicContainer>
</template>

<script>
    export default {
        data() {
            return {
                xndm:'',
                xydm:'',
                obj:{},
                mainTable: {
                    buttonSetting: {
                        allowAdd: false,
                        allowEdit: false,
                        allowDelete: false,
                        allowView: false,
                        left: [{
                            title: '返回',
                            type: 'primary',
                            clickEvent: 'goReturn',
                            icon: 'fa fa-arrow-circle-left'
                        }],
                        right: []
                    },
                    header: {
                        title: '班级切片管理'
                    },
                    table: {
                        loading: false,
                        height: 550,
                        stripe: true,
                        conditionLabelWidth: 'auto',
                        selection: false,
                        index: false,
                        columns: [{
                            prop: 'xn',
                            label: '参评学年',
                            isSearchCondition: true,
                            type: 'select',
                            span: 12,
                            showInTable: false,
                            required: true,
                            dicData: [],
                            searchChangeFunction: 'xnChange',
                        },{
                            prop: 'xydm',
                            label: '参评学院',
                            isSearchCondition: true,
                            type: 'select',
                            showInTable: false,
                            required: true,
                            span: 12,
                            dicData: [],
                            searchChangeFunction: 'xyChange',
                        }, {
                            prop: 'bjmc',
                            label: '参评班级',
                            isSearchCondition: false,
                            type: 'input',
                            required: true,
                            slotName:'bjmcForm',
                            rows: 5,
                            span: 12,
                            dicData: []
                        }, {
                            prop: 'count',
                            label: '参评总人数',
                            isSearchCondition: false,
                            type: 'input',
                            required: true,
                            rows: 5,
                            span: 12,
                            dicData: []
                        }, {
                            prop: 'zymc',
                            label: '专业名称',
                            isSearchCondition: false,
                            type: 'input',
                            showInTable: false,
                            rows: 5,
                            span: 12,
                            dicData: []
                        }, {
                            prop: 'zydm',
                            label: '专业代码',
                            isSearchCondition: false,
                            type: 'input',
                            required: true,
                            showInTable: false,
                            rows: 5,
                            span: 12,
                            dicData: []
                        }],
                        operation: {
                            width: '220',
                        },
                        tableData: [],
                        paging: {
                            currentPage: 1,
                            pageSizes: [10, 15, 20, 25],
                            pageSize: 10,
                            total: 0
                        },
                        reload: 'mainTableReload',
                        reloadConditions: {},
                        addDefultValue: {}
                    }

                },
                // 缓存年级
                njArray:[]
            }
        },

        mounted() {
            let that = this
            console.log(that.$route.query)
            let {bjqpPageNo} = that.$route.query
            let {bjqpTotal} = that.$route.query
            console.log(bjqpTotal + ' ==== '+bjqpPageNo)
            that.mainTable.table.paging.currentPage = bjqpPageNo || 1
            that.mainTable.table.paging.total = bjqpTotal

           setTimeout(function () {
               //学年
               that.getXN()
               //学院
               that.getXY()
           }, 1000)

        },
        methods: {
            //获取url参数
            getQueryVariable: function(variable){
                let query = location.href.substr(location.href.indexOf('?')+1)
                let vars = query.split("&");
                for (let i=0;i<vars.length;i++) {
                    let pair = vars[i].split("=");
                    if(pair[0] == variable){return pair[1];}
                }
                return(false);
            },

            mainTableReload: function(params) {
                if(this.$route.query.bjqpPageNo != undefined){
                    this.mainTable.table.paging.currentPage = Number(this.$route.query.bjqpPageNo)
                    params.pageNum = this.$route.query.bjqpPageNo
                }
                let that = this
                setTimeout(function () {
                    console.log('xydm:'+params.xydm+'-----'+'xn:'+params.xn)
                    if(params.xydm!='' && params.xn == undefined){
                        that.$message.warning('请选择参评学年')
                        return
                    }
                    if(params.xn!='' && params.xydm == undefined){
                        that.$message.warning('请选择参评学院')
                        return
                    }
                    that.obj= params
                    that.mainTable.table.loading = true
                    that.$http.get('/qpxx/listFromXy',{
                        params
                    }).then(
                        response => {
                            that.mainTable.table.loading = false
                            // 成功之后的数据
                            that.mainTable.table.tableData = response.data.records
                            that.mainTable.table.paging.total = response.data.total || response.data.records.length
                            that.obj.total = response.data.total
                            console.log(this.obj)
                            return true

                        }
                    ).catch(
                        error => {
                            that.$message.error(error.msg)
                        }
                    )
                }, 100)
            },

            getXY: function() {
                this.$http.post('/college/getCollegeCode').then(response => {
                    let result = []
                    response.data.forEach(element => {
                        result.push({
                            label: element.bmmc,
                            value: element.bmdm
                        })
                    })
                    this.$refs.mainTable.setColumnSeting('xydm', 'dicData', result)
                    if(result.length!==0){
                        this.mainTable.table.reloadConditions.xydm =  this.getQueryVariable('cpxy')
                        let that = this
                        setTimeout(function () {
                            that.$refs.mainTable.reload()
                        }, 100)
                    }

                }).catch(error => {
                    this.$message.error(error.msg)
                })
            },

            xnChange: function(e){
                this.xndm = e.value
            },
            xyChange: function(e){
                this.xydm = e.value
            },
            openFun: function (row) {
                this.$router.push({name:'班级明细', query: {xn: this.xndm, cpxy: this.xydm, bjdm: row.bjmc, bjmc: row.bjmc, zycm:row.zymc, zydm: row.zydm, bjqpPageNo: this.obj.pageNum, bjqpTotal: this.obj.total,pageNo: this.$route.query.pageNo, total: this.$route.query.total}})
            },
            goReturn: function () {
                this.$router.push({name:'学院切片管理', query: {xn: this.$route.query.xn, pageNo: this.$route.query.pageNo, total: this.$route.query.total}})

            },
            sortBy: function(attr,rev){
                //第二个参数没有传递 默认升序排列
                if(rev ==  undefined){
                    rev = 1;
                }else{
                    rev = (rev) ? 1 : -1;
                }

                return function(a,b){
                    a = a[attr];
                    b = b[attr];
                    if(a < b){
                        return rev * -1;
                    }
                    if(a > b){
                        return rev * 1;
                    }
                    return 0;
                }
            },
            getXN:function () {
                this.$http.get('/Xn/queryMap').then(response => {
                    let result = []
                    response.data.forEach(element => {
                        result.push({
                            label: element.xnd,
                            value: element.id
                        })
                    })
                    result=result.sort(this.sortBy('label',false));
                    this.$refs.mainTable.setColumnSeting('xn', 'dicData', result)
                    let that = this
                    if(result.length!==0){
                        that.mainTable.table.reloadConditions.xn = that.getQueryVariable('xn')
                    }

                }).catch(error => {
                    this.$message.error(error.msg)
                })

            }


        }
    }
</script>

<style lang='scss'>

    .quill-editor {
        height: 300px;
    }
    .easyCrud .el-form-item {
        height: 44px !important;
    }
</style>
